/** Small "Config 2 of 3" tag rendered under a repeated model year in spec tables. */
export function ConfigTag({ label }: { label: string | null | undefined }) {
  if (!label) return null;
  return (
    <span className="mt-0.5 block text-[11px] font-normal leading-tight text-muted-foreground">
      {label}
    </span>
  );
}
